import React, { useEffect, useState, forwardRef } from 'react';
import '../styles/InclusionExclusion.css';
import BASE_URL from '../config';

const mockTour = {
  Inclusions: 'Flight tickets, Accommodation, Daily breakfast, Local transport',
  Exclusions: 'Visa fees, Personal expenses, Travel insurance',
};

const InclusionExclusion = forwardRef((props, ref) => {
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}/api/tour`)
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => {
        setTour(data);
        setLoading(false);
      })
      .catch(() => {
        setTour(mockTour);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!tour) return null;

  const inclusions = tour?.Inclusions ? tour.Inclusions.split(',').map(item => item.trim()) : [];
  const exclusions = tour?.Exclusions ? tour.Exclusions.split(',').map(item => item.trim()) : [];

  return (
    <div className='inclusion-exclusion' ref={ref} style={{ margin: '20px' }}>
      <div className='inclusion'>
        <div className='inclusion-header'>
          <div className='rectangle-green'></div>
          <div className='inclusion-exclusion-title'>Inclusion</div>
        </div>
        <ul>
          {inclusions.length > 0 ? (
            inclusions.map((item, idx) => <li key={idx}>{item}</li>)
          ) : (
            <li>No inclusions listed.</li>
          )}
        </ul>
      </div>

      <div className='exclusion'>
        <div className='exclusion-header'>
          <div className='rectangle-red'></div>
          <div className='inclusion-exclusion-title'>Exclusion</div>
        </div>
        <ul>
          {exclusions.length > 0 ? (
            exclusions.map((item, idx) => <li key={idx}>{item}</li>)
          ) : (
            <li>No exclusions listed.</li>
          )}
        </ul>
      </div>
    </div>
  );
});

export default InclusionExclusion;
